import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';


interface OrgWithCountResponse {
  rows: any[];
  count: number;
}

@Injectable({
  providedIn: 'root'
})
export class OrganizationService {

  constructor(private http: HttpClient) { }

  createOrganization(data: any): Observable<any> {
    return this.http.post(environment.createOrganization, data);
  }

  getAllOrgWithCount(body: any): Observable<OrgWithCountResponse> {
    return this.http.post<OrgWithCountResponse>(environment.getAllOrgWithCount, body);
  }

  deleteOrganization(body: { organization_id: string }): Observable<any> {
    return this.http.post(environment.deleteOrganization, body);
  }

  getOrganizationById(body: { organization_id: string }): Observable<any> {
    return this.http.post(environment.getOrganizationById, body);
  }

  /* getAllCampus(payload: { organization_id: string }) {
    return this.http.post<any>(environment.getAllCampus, payload);
  }  */
  getAllCampus(body: { organization_id: string }): Observable<any> {
    return this.http.post<any>(environment.getAllCampus, body);
  }


  getAllDepartment(payload: { organization_id: string }) {
    return this.http.post<any>(environment.getAllDepartment, payload);
  }

  getAllRoles(payload: { organization_id: string }) {
    return this.http.post<any>(environment.getAllRoles, payload);
  }

  getAllUsers(payload: any) {
    return this.http.post<any>(environment.getAllUsers, payload);
  }

  deleteUser(payload:any) {
    return this.http.post(environment.deleteUser, payload);
  }
  createCampus(data: any) {
    return this.http.post(environment.createCampus, data);
  }

  updateCampus(payload: any) {
    return this.http.post(environment.updateCampus, payload); // Adjust URL if needed
  }

  /* deleteCampus(campus_id: string) {
    return this.http.delete(`${environment.deleteCampus}/${campus_id}`);
  } */
  deleteCampus(payload: { campus_id: string }) {
    return this.http.post(environment.deleteCampus, payload);
  }

  deleteDepartment(payload: any) {
    return this.http.post(environment.deleteDepartment, payload);
  }

  createDepartment(data: any) {
    return this.http.post(environment.createDepartment, data);
  }

  updateDepartment(data: any) {
    return this.http.post(environment.updateDepartment, data);
  }

  /* deleteDepartment(dept_id: string) {
    return this.http.delete(`${environment.deleteDepartment}/${dept_id}`);
  } */
  updateOrganization(data: any) {
    return this.http.post(environment.updateOrganization, data);
  }

  createUser(data: any): Observable<any> {
    return this.http.post(environment.createUser, data);
  }
  updateUser(data: any): Observable<any> {
    return this.http.post(environment.updateUser, data);
  }

  getAllRole(payload: any): Observable<any> {
    return this.http.post(environment.getAllRole, payload);
  }

  createRole(data: any): Observable<any> {
    return this.http.post(environment.createRole, data);
  }

  updateRole(data: any): Observable<any> {
    return this.http.post(environment.updateRole, data);
  }

  deleteRole(payload: any): Observable<any> {
    return this.http.post(environment.deleteRole, payload);
  }

  getCounterById(data : any) : Observable<any>{
    return this.http.post(environment.getCounterById, data);
  }

  getAllCourses(payload: any) :Observable<any> {
    return this.http.post(environment.getAllCourses, payload);
  }

  createCourse(data: any) :  Observable<any> {
    return this.http.post(environment.createCourse, data);
  }


  getOrgPackageById(data: any): Observable<any> {
    return this.http.post(environment.getOrgPackageById, data);
  }

  createOrgnizationPackage(data: any): Observable<any> {
    return this.http.post(environment.createOrgPackage, data);
  }

  updateOrganizationPackage(data: any): Observable<any> {
    return this.http.post(environment.updateOrgPackage, data);
  }


  createOrgConfig(data: any): Observable<any> {
    return this.http.post(environment.createOrgConfig, data);
  }

  updateOrgConfig(data: any): Observable<any> {
    return this.http.post(environment.updateOrgConfig, data);
  }

  getOrgConfigById(data: any): Observable<any> {
    return this.http.post(environment.getOrgConfigById, data);
  }

  createCounter(data: any): Observable<any> {
    return this.http.post(environment.createCounter, data);
  }

  updateCounter(data: any): Observable<any> {
    return this.http.post(environment.updateCounter, data);
  }
}